import $ from 'jquery';

export default function Stuff(vm) {
    this.all = function(params) {
        var url = '/stuff/list?' + $.param(params);

        return vm.get(url);
    };

    this.create = function(params) {
        var url = '/stuff/create';

        return vm.post(url, params);
    };

    this.get = function(id) {
        var url = '/stuff/detail/' + id;

        return vm.get(url);
    };

    this.delete = function(params) {
        var url = null;

        if (params.is_permanent == 1)
            url = '/stuff/force-delete/' + params.id;
        else
            url = '/stuff/delete/' + params.id;

        return vm.delete(url);
    };

    this.restore = function(id) {
        var url = '/stuff/restore/' + id;

        return vm.get(url);
    };

    this.copy = function(id) {
        var url = '/stuff/copy/' + id;

        return vm.get(url);
    };

    this.rotate = function(params) {
        var url = '/stuff/rotate/' + params.id;

        return vm.post(url, params);
    };

    this.move = function(params) {
        var url = '/stuff/move/' + params.id;

        return vm.post(url, params);
    };

    this.layer = function(params) {
        var url = '/stuff/layer/' + params.id;

        return vm.post(url, params);
    };
}